import {useRef} from 'react';

export const useRunOnce = (fn: () => void) => {
    const hasRun = useRef(false);
    if (!hasRun.current) {
        hasRun.current = true;
        fn();
    }
};
